(function () {
  'use strict';
  if (window.__stadeskDuoEntry) return;
  window.__stadeskDuoEntry = true;
  function sync() {
    var links = Array.from(document.querySelectorAll('a[href*="/pages/configurator-duo"]'));
    var source = links.find(function (a) { return new URL(a.href).searchParams.has('material'); });
    if (!source) return;
    var base = new URL(source.href);
    var size = document.querySelector('input[data-option-name="Bladmaat"]:checked');
    var frame = document.querySelector('input[data-option-name="Onderstel"]:checked');
    var dimensions = size && size.value.match(/(\d+)\s*[x×]\s*(\d+)\s*(?:cm)?\s*$/i);
    links.forEach(function (link) {
      var url = new URL(link.href);
      if (url.origin !== location.origin || url.pathname !== '/pages/configurator-duo') return;
      ['material', 'color'].forEach(function (key) { if (base.searchParams.has(key)) url.searchParams.set(key, base.searchParams.get(key)); });
      if (dimensions) { url.searchParams.set('width', dimensions[1]); url.searchParams.set('depth', dimensions[2]); }
      if (frame && /^(Zwart|Wit)$/i.test(frame.value)) url.searchParams.set('frame', /^Wit$/i.test(frame.value) ? 'white' : 'black');
      // Explicit product choices take precedence over an older saved design.
      url.searchParams.delete('cfg');
      link.setAttribute('href', url.pathname + url.search);
    });
  }
  document.addEventListener('change', sync);
  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('a[href*="/pages/configurator-duo"]')) sync();
  }, true);
  document.addEventListener('shopify:section:load', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
